import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';

import { HCPStatisticService } from '../../services/hcpstatistic.service';
import { BasicError, Error403 } from '../../models/error/error';

import { User } from '../../models/user';
import { Alarm } from '../../models/alarm';
import { Study } from '../../models/study';
import { AlarmService } from '../../services/alarm.service';

@Component({
  selector: 'app-hcp-dashboard',
  templateUrl: './hcp-dashboard.component.html',
  styleUrls: ['./hcp-dashboard.component.css']
})
export class HcpDashboardComponent implements OnInit {
  public alarmLength = 0;
  public alarms = [];
  public warnings = [];
  public allUsers = {};
  public users = [];
  public amounts = {};
  public studies = [];
  public studyMembers = {};
  public studyCollaborators = {};
  public amountMembers = 0;
  public amountCollaborators = 0;

  constructor(private authenticationService: AuthenticationService,
    private hcpStatistic: HCPStatisticService, private alarm: AlarmService) {
    this.amountMembers = 0;
    this.amountCollaborators = 0;
    this.alarm.observe().subscribe(json => {
      const rr = this.alarm.getCurrentAlarms();
      this.alarms = rr.alarms;
      this.warnings = rr.warnings;

      this.allUsers = {};
      this.users = [];

      for (const a of this.alarms) {
        if (a instanceof Alarm) {
          if (this.allUsers[a.getUser().getID().toString()] === undefined) {
            this.allUsers[a.getUser().getID().toString()] = a.getUser();
            this.users.push(a.getUser());
            this.amounts[a.getUser().getID().toString()] = 1;
          } else {
            this.amounts[a.getUser().getID().toString()] = this.amounts[a.getUser().getID().toString()] + 1;
          }
        }
      }

      for (const a of this.warnings) {
        if (a instanceof Alarm) {
          if (this.allUsers[a.getUser().getID().toString()] === undefined) {
            this.allUsers[a.getUser().getID().toString()] = a.getUser();
            this.users.push(a.getUser());
            this.amounts[a.getUser().getID().toString()] = 1;
          } else {
            this.amounts[a.getUser().getID().toString()] = this.amounts[a.getUser().getID().toString()] + 1;
          }
        }
      }
    });

    const rr = this.alarm.getCurrentAlarms();
    this.alarms = rr.alarms;
    this.warnings = rr.warnings;

    this.allUsers = {};
    this.users = [];

    for (const a of this.alarms) {
      if (a instanceof Alarm) {
        if (this.allUsers[a.getUser().getID().toString()] === undefined) {
          this.allUsers[a.getUser().getID().toString()] = a.getUser();
          this.users.push(a.getUser());
          this.amounts[a.getUser().getID().toString()] = 1;
        } else {
          this.amounts[a.getUser().getID().toString()] = this.amounts[a.getUser().getID().toString()] + 1;
        }
      }
    }

    for (const a of this.warnings) {
      if (a instanceof Alarm) {
        if (this.allUsers[a.getUser().getID().toString()] === undefined) {
          this.allUsers[a.getUser().getID().toString()] = a.getUser();
          this.users.push(a.getUser());
          this.amounts[a.getUser().getID().toString()] = 1;
        } else {
          this.amounts[a.getUser().getID().toString()] = this.amounts[a.getUser().getID().toString()] + 1;
        }
      }
    }

    this.hcpStatistic.getCollaboratingStudies().subscribe(json => {
      if (json instanceof BasicError) {
        console.log('Could not get collaborating studies');
      } else {
        this.studies = json;
        // Now get some other data (members, answersheets etc)
        for (const study of this.studies) {
          this.getMembers(study);
          this.getCollaborators(study);
        }
      }
    });
  }

  ngOnInit() {
  }

  /**
   * Getting all members of this studies
   * @param study study to get members of
   */
  public getMembers(study: Study) {
    this.hcpStatistic.getAmountMembers(study.getId()).subscribe(json => {
      if (json instanceof BasicError) {
        console.log('Could not get amount members');
      } else {
        this.studyMembers[study.getId().toString()] = json;
        this.amountMembers = this.amountMembers + json;
      }
    });
  }

  /**
   * getting amount collaborators
   * @param study
   */
  public getCollaborators(study: Study) {
    this.hcpStatistic.getAmountCollaborators(study.getId()).subscribe(json => {
      if (json instanceof BasicError) {
        console.log('Could not get amount collaborators');
      } else {
        this.studyCollaborators[study.getId().toString()] = json.count;
        this.amountCollaborators = this.amountCollaborators + json.count;
      }
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/hcp-dashboard/hcp-dashboard.component.ts